var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wkb-locuszoom-pane" },
    [
      !_vm.hasInput
        ? _c("div", { staticClass: "wkb-locuszoom-empty" }, [
            _vm._v(
              " Locus plot unavailable for this edge because the gene or trait identifier is missing. "
            ),
          ])
        : [
            _c("div", { staticClass: "wkb-locuszoom-head" }, [
              _c("div", [
                _c("h4", { staticClass: "wkb-locuszoom-title" }, [
                  _vm._v("Locus plot"),
                ]),
                _c("p", { staticClass: "wkb-inspector-note" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.region
                          ? `${_vm.region.gene} ± ${_vm.formatCoordinate(
                              _vm.region.flank
                            )} bp on chr${
                              _vm.region.chromosome
                            }:${_vm.formatCoordinate(
                              _vm.region.start
                            )}-${_vm.formatCoordinate(_vm.region.end)}`
                          : `${_vm.locusZoom.gene} ± ${_vm.formatCoordinate(
                              _vm.locusZoom.flank || 250000
                            )} bp`
                      ) +
                      " "
                  ),
                ]),
              ]),
              _vm.status !== "ready"
                ? _c("span", { staticClass: "wkb-locuszoom-status" }, [
                    _c("span", {
                      staticClass: "wkb-locuszoom-spinner",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.status === "loading-region"
                            ? "Loading region"
                            : "Loading associations"
                        ) +
                        " "
                    ),
                  ])
                : _c("div", { staticClass: "wkb-locuszoom-head-meta" }, [
                    _vm._m(0),
                    _c("span", { staticClass: "wkb-locuszoom-status" }, [
                      _vm._v(_vm._s(_vm.associations.length) + " variants"),
                    ]),
                  ]),
            ]),
            _vm.error
              ? _c(
                  "p",
                  {
                    staticClass: "wkb-inspector-note wkb-inspector-note--warn",
                  },
                  [_vm._v(_vm._s(_vm.error))]
                )
              : _vm._e(),
            _c("div", { staticClass: "wkb-locuszoom-plot" }, [
              _c("canvas", {
                ref: "plotCanvas",
                staticClass: "wkb-locuszoom-canvas",
                attrs: {
                  "aria-label": `Association plot for ${_vm.locusZoom.gene} and ${_vm.locusZoom.trait_id}`,
                },
                on: {
                  mousemove: _vm.onPlotMouseMove,
                  mouseleave: function ($event) {
                    _vm.hovered = null
                  },
                },
              }),
              _vm.hovered
                ? _c(
                    "div",
                    {
                      staticClass: "wkb-locuszoom-tooltip",
                      style: {
                        left: `${_vm.hovered.x}px`,
                        top: `${_vm.hovered.y}px`,
                      },
                    },
                    [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.hovered.variant || _vm.hovered.id)),
                      ]),
                      _c("span", [
                        _vm._v(
                          "p-value: " +
                            _vm._s(_vm.formatPValue(_vm.hovered.pValue))
                        ),
                      ]),
                      _c("span", [
                        _vm._v("beta: " + _vm._s(_vm.hovered.beta ?? "NA")),
                      ]),
                      _c("span", [
                        _vm._v(
                          "consequence: " +
                            _vm._s(_vm.hovered.consequence || "NA")
                        ),
                      ]),
                      _c("span", [
                        _vm._v(
                          "nearest: " +
                            _vm._s(_vm.nearestLabel(_vm.hovered.nearest))
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
            _vm.region
              ? _c("div", { staticClass: "wkb-locuszoom-gene-track-panel" }, [
                  _c(
                    "div",
                    { staticClass: "wkb-locuszoom-gene-track-toolbar" },
                    [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.includeNonProteinCodingGenes
                                ? `${_vm.allGeneCount} genes shown`
                                : `${_vm.proteinCodingGeneCount} protein-coding genes shown`
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "label",
                        { staticClass: "wkb-locuszoom-gene-toggle" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.includeNonProteinCodingGenes,
                                expression: "includeNonProteinCodingGenes",
                              },
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.includeNonProteinCodingGenes
                              )
                                ? _vm._i(
                                    _vm.includeNonProteinCodingGenes,
                                    null
                                  ) > -1
                                : _vm.includeNonProteinCodingGenes,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.includeNonProteinCodingGenes,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.includeNonProteinCodingGenes =
                                        $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.includeNonProteinCodingGenes = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.includeNonProteinCodingGenes = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" Show non-protein-coding genes "),
                        ]
                      ),
                    ]
                  ),
                  _vm.region.gene_track_error
                    ? _c("p", { staticClass: "wkb-locuszoom-track-warning" }, [
                        _vm._v(
                          " Gene-track lookup timed out; showing the focus gene only. "
                        ),
                      ])
                    : _vm._e(),
                  _c("canvas", {
                    ref: "geneCanvas",
                    staticClass: "wkb-locuszoom-gene-canvas",
                    attrs: {
                      "aria-label": `Gene track for ${
                        _vm.region.region || _vm.locusZoom.gene
                      }`,
                    },
                    on: {
                      mousemove: _vm.onGeneMouseMove,
                      mouseleave: function ($event) {
                        _vm.hoveredGene = null
                      },
                    },
                  }),
                  _vm.hoveredGene
                    ? _c(
                        "div",
                        {
                          staticClass: "wkb-locuszoom-tooltip",
                          style: {
                            left: `${_vm.hoveredGene.x}px`,
                            top: `${_vm.hoveredGene.y}px`,
                          },
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.hoveredGene.symbol)),
                          ]),
                          _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.hoveredGene.chromosome) +
                                ":" +
                                _vm._s(
                                  _vm.formatCoordinate(_vm.hoveredGene.start)
                                ) +
                                "-" +
                                _vm._s(
                                  _vm.formatCoordinate(_vm.hoveredGene.end)
                                ) +
                                " "
                            ),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.hoveredGene.type || "gene")),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "wkb-locuszoom-legend",
        attrs: { "aria-label": "Locus plot color legend" },
      },
      [
        _c("span", [
          _c("i", {
            staticClass: "wkb-locuszoom-dot wkb-locuszoom-dot-positive",
          }),
          _vm._v(" beta >= 0"),
        ]),
        _c("span", [
          _c("i", {
            staticClass: "wkb-locuszoom-dot wkb-locuszoom-dot-negative",
          }),
          _vm._v(" beta < 0"),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }